<template>
    <router-link :to="routeData">
        <slot></slot>
    </router-link>
</template>

<script>
    // Routing component to simplify <router-link> expressions.
    // Using router-link to get the edit page for user 1 would be: <router-link :to="{ name: "users.edit", params: { id: 1 }}"></router-link>
    // With this component you can write: <route-to name="users.edit" id="1"></route-to>
    export default {
        name: "RouteTo",
        props: {
            // Name of destination route
            name: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                routeData: {}
            }
        },
        methods: {
            // Construct underlying router-link component
            define() {
                let obj = {
                    name: this.name,
                    params: {}
                };

                if (this.$attrs !== undefined) {
                    for (let attr in this.$attrs) {
                        if (this.$attrs.hasOwnProperty(attr)) {
                            obj.params[attr] = this.$attrs[attr];
                        }
                    }
                }

                return this.routeData = obj;
            }
        },
        mounted() {
            this.define();
        }
    }
</script>

<style scoped>

</style>